<template>
  <div id="ExemptionExams">
    <ots-main-title></ots-main-title>
    <ots-table-group-new
      ref="ots-table"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :batchOperBtn="batchOperBtn"
    ></ots-table-group-new>

    <!-- 新增免考原因 -->
    <ots-custom-dialog :dialog.sync="addReasonDialog" :title="isEdit ? '编辑免考原因': '新增免考原因'" width="40%">
      <template v-slot:content>
        <p>
          <span>免考原因名称：</span>
          <el-input placeholder="请录入" v-model="reasonName"></el-input>
        </p>

        <br />
        <p>
          <span>免考材料上传说明：</span>
          <el-input placeholder="请录入" v-model="remark"></el-input>
        </p>
      </template>
      <template v-slot:footer>
        <el-button round @click="addReasonDialog = false">取消</el-button>
        <el-button round @click="addReasonSave">保存</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import { getReasonListAPI, saveReasonAPI, updateReasonAPI, operationReasonAPI } from "@/http/modules/examSet/score";
export default {
  data() {
    return {
      batchOperBtn: [
        {
          title: "新增免考原因",
          icon: "iconfont icon-tianjia",
          click: this.addReason,
        },
      ],
      tableHeader: [
        {
          title: "免考原因",
          prop: "reasonName",
        },
        {
          title: "上传说明",
          prop: "remark",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              title: "编辑",
              click: this.edit,
            },
            {
              title: "删除",
              click: this.delete,
            },
            {
              title: "停用",
              click: this.stopUse,
              formatter: function(scope) {
                return scope.row.stopFlag == 1;
              }
            },
            {
              title: "启用",
              click: this.startUse,
              formatter: function(scope) {
                return scope.row.stopFlag == 0;
              }
            },
          ],
        },
      ],
      tableData: [],
      addReasonDialog: false,
      reasonId: "",
      reasonName: "",
      remark: "",
      isEdit: false,
    }
  },

  mounted() {
    this.getTableData();
  },

  methods: {
    async getTableData() {
      const { data } = await getReasonListAPI();
      this.tableData = data;
    },
    // 新增免考弹窗
    addReason() {
      this.reasonName = "";
      this.remark = "";
      this.isEdit = false;
      this.addReasonDialog = true;
    },
    // 保存
    async addReasonSave() {
      if (this.reasonName.length > 50) {
        this.$message.error("免考原因最多可录入 50 字！")
        return false;
      }
      if (this.remark && this.remark.length > 100) {
        this.$message.error("免考材料上传说明最多可录入 100 字！")
        return false;
      }
      if (this.isEdit) {
        let params = {
          reasonId: this.reasonId,
          reasonName: this.reasonName,
          remark: this.remark
        }
        const { code } = await updateReasonAPI(params);
        if (code) {
          this.$message.success("编辑成功！");
        }
      } else {
        let params = {
          reasonName: this.reasonName,
          remark: this.remark
        }
        const { code } = await saveReasonAPI(params);
        if (code) {
          this.$message.success("添加成功！");
        }
      }
      this.addReasonDialog = false;
      this.getTableData();
    },
    // 编辑
    edit(row) {
      this.reasonId = row.reasonId;
      this.reasonName = row.reasonName;
      this.remark = row.remark;
      this.isEdit = true;
      this.addReasonDialog = true;
    },
    // 删除
    async delete(row) {
      this.$confirm(`确认删除 ${row.reasonName} ？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let params = {
          reasonId: row.reasonId,
          operationType: 2
        }
        const { code } = await operationReasonAPI(params);
        if (code == 1) {
          this.$message.success("删除成功！");
        }
        this.getTableData();
      })
    },
    // 停用
    async stopUse(row) {
      let params = {
        reasonId: row.reasonId,
        operationType: 1
      }
      const { code } = await operationReasonAPI(params);
      if (code == 1) {
        this.$message.success(`${row.reasonName} 停用成功！`);
      }
      this.getTableData();
    },
    // 启用
    async startUse(row) {
      let params = {
        reasonId: row.reasonId,
        operationType: 0
      }
      const { code } = await operationReasonAPI(params);
      if (code == 1) {
        this.$message.success(`${row.reasonName} 启用成功！`);
      }
      this.getTableData();
    },
  }
}
</script>